import React from "react";
import { Helmet } from 'react-helmet';
import ReadMoreAndLess from 'react-read-more-less';

const Landing = () => {
    return (
        <section>
            <Helmet>
                <title>Aarohi Hospital: Obstetrics & Gynaecology</title>
            </Helmet>

            <div className="about-section obstetrics-section-background bg-white py-4 mt-5">
                <div className="container pt-5">
                    <div className="row align-items-center">
                        <div className="col-lg-6 pb-30">
                            <div className="about-section-item about-item-details">
                                <div className="section-title section-title-left text-start">
                                    <h1 className="c-blue font-weight-bolder">Obstetrics & Gynaecology</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-section bg-off-white pt-4 pb-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="about-section-item about-item-details">
                            
                                <div className="about-content">
                                    <p className="font-weight-normal">At Aarohi Hospital, we understand that women’s health needs are unique and evolving. Our Obstetrics & Gynaecology department provides comprehensive care from adolescence to motherhood and beyond.</p>
                                    <p className="font-weight-normal">We specialize in normal and painless deliveries, high-risk pregnancy management, Caesarean sections, infertility evaluation, menstrual disorders, PCOS, uterine fibroids, and menopausal care. Our well-equipped labour rooms, experienced obstetricians, and 24/7 emergency services ensure safe deliveries and personalized attention. We emphasize ethical practice, informed decision-making, and emotional support for every woman and family.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
        </section>
    );
};

export default Landing;
